import React from "react";

import { Stack } from "@chakra-ui/react";
import Item from "./Item";

const Items = ({ routes }) => {
  return (
    <Stack direction="column" mb="40px">
      {routes.map((item, index) => (
        <Item key={index} name={item.name} icon={item.icon} path={item.path} />
      ))}
    </Stack>
  );
};

export default Items;
